<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title">{{positionModalHeading}}</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="modals.add-position.close-btn"
                (click)="cancel()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>

<div class="modal-body">
    <form  [formGroup]="positionForm" novalidate>
        <div class="col-md-12 col-sm-12 col-xs-12 ps-0 pe-0">
            <div class="col-md-5 col-sm-3 col-xs-3 inline-grid pe-0">
                <label class="col-md-12 col-sm-12 ps-0 pb-1" for="add-position-symbol">
                    Symbol
                </label>
                <div class="col-md-12 col-sm-12  ps-0 pe-0">
                    <input type="text" class="form-control" id="add-position-symbol" name="symbol" formControlName="symbol" placeholder="Symbol"
                        [(ngModel)]="selectedPosition.symbol" (blur)="getTicker(selectedPosition)"
                        data-testid="modals.add-position.symbol-input" />
                </div>
                <div *ngIf="positionFormSubmitted" class="text-danger" role="alert">
                    <div *ngIf="formControl.symbol.errors?.required">Please enter the Symbol.
                    </div>
                    <div *ngIf="formControl.symbol.errors?.invalidSymbol">
                        Please enter the Valid Symbol.
                    </div>
                </div>
            </div>

            <div class="col-md-7 col-sm-3 col-xs-3 inline-grid ">
                <label class="col-md-3 col-sm-3 ps-0" for="add-position-description">
                    Description
                </label>
                <div class="col-md-12 col-sm-3 ps-0 pe-0">
                    <input type="text" class="form-control" id="add-position-description" name="name" formControlName="description"
                        placeholder="Description" [(ngModel)]="selectedPosition.description"
                        ng-disabled="checkCustomTicker"
                        data-testid="modals.add-position.description-input" />
                </div>
            </div>
        </div>
        <div class="clear"></div>
        <div class="col-md-12 col-sm-12 col-xs-12 ps-0 pe-0 mt-3">
            <div class="col-md-5 col-sm-12 col-xs-12 inline-grid pe-0">
                <label class="col-md-3 col-sm-3 ps-0" for="add-position-value">
                    Value
                </label>
                <div class="col-md-12 col-sm-3 ps-0 pe-0">
                    <input type="number" class="form-control" id="add-position-value" name="valueName" formControlName="valueName"
                        (blur)="generateQuantityorValue('generateQuantity')" placeholder="Value"
                        [(ngModel)]="selectedPosition.amount"
                        data-testid="modals.add-position.value-input" />
                </div>
                <div *ngIf="positionFormSubmitted" class="text-danger" role="alert">
                    <div *ngIf="formControl.valueName.errors?.required">Please enter the Value.
                    </div>
                </div>
            </div>
            <div class="col-md-7 col-sm-12 col-xs-12 inline-grid pe-0">
                <label class="col-md-3 col-sm-3 ps-0" for="add-position-quantity">
                    Quantity
                </label>
                <div class="col-md-12 col-sm-3 ps-0">
                    <input (disabled)="disableQuantity" type="number" class="form-control" id="add-position-quantity" name="quantity"
                        formControlName="quantity" (blur)="generateQuantityorValue('generateValue')"
                        placeholder="Quantity" [(ngModel)]="selectedPosition.quantity"
                        data-testid="modals.add-position.quantity-input" />
                </div>
                <div *ngIf="positionFormSubmitted" class="text-danger" role="alert">
                    <div *ngIf="formControl.quantity.errors?.required">Please enter the Quantity.
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="cancel()"
        data-testid="modals.add-position.cancel-btn">
        CANCEL
    </button>
    <button type="button" class="btn btn-primary btn-sm rounded-pill" (click)="savePosition()"
        data-testid="modals.add-position.save-btn">
        Save
    </button>
</div>
